<div class="container-fluid p-0 edit-profile-page">
  <HeaderSection :breadcrumb="breadcrumb" @breadcrumb-click="handleBreadcrumbClick" />
  <section class="container edit-profile-content py-4 py-lg-5"><div class="glass-card edit-profile-card rounded-4">
    <div class="edit-profile-heading d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 mb-4">
      <div>
        <span class="edit-profile-eyebrow">Account settings</span>
        <h4 class="text-white fw-bold mb-1">{{ is_editing_managed_user() ? "Edit User" : "Edit Profile" }}</h4>
        <p class="text-white-50 text-sm mb-0">Keep your account details accurate and up to date.</p>
      </div>
      <span class="edit-profile-badge"><i class="bi bi-shield-check me-2"></i>Secure profile</span>
    </div>
    <form @submit.prevent="saveProfile">
      <p v-if="error_message" class="edit-profile-error text-danger text-xs mb-3"><i class="bi bi-exclamation-circle me-2"></i>{{ error_message }}</p>
      <div class="edit-profile-identity d-flex align-items-center gap-3 mb-4">
        <div class="profile-avatar d-flex align-items-center justify-content-center" aria-label="User initials"><span class="profile-avatar-text">{{ avatar_initials }}</span></div>
        <div><div class="text-white fw-semibold">{{ form.first_name }} {{ form.last_name }}</div><div class="text-white-50 text-xs">{{ form.email }}</div></div>
      </div>
      <UserEditForm :form="form" :is-saving="false" submit-label="Save Changes" @cancel="cancelEdit" />
    </form>
  </div></section>
</div>
